import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { defaultLongCacheTime } from 'queryClient'
import { useQuery } from 'react-query'
import { AlmanacFile } from 'types'

export const useUploadsProject = (workspaceId: number) => {
  return useQuery<{ project: AlmanacFile | null }>(
    ['uploadsProject', workspaceId],
    async () => {
      const res = await WorkspaceClient.getUploadsProject(workspaceId)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      cacheTime: defaultLongCacheTime,
      refetchOnWindowFocus: false,
    },
  )
}
